module.exports = __webpack_public_path__ + "static/media/FolderGreenDark.82ff6ead.svg";